import { http } from '../index';

export const getTrainingModule = id =>
  http
    .get(`/training-modules/${id}`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const getTrainingModulesList = params =>
  http
    .get('/training-modules/list', { params })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const createTrainingModule = formData =>
  http
    .post('/training-modules', formData)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const updateTrainingModule = (id, formData) =>
  http
    .put(`/training-modules/${id}`, formData)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const deleteTrainingModule = id =>
  http
    .delete(`/training-modules/${id}`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const getCompanyTrainingModuleTrainers = trainingModuleId =>
  http
    .get(`/training-modules/${trainingModuleId}/company-trainers`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const updateCompanyTrainingModuleTrainers = (trainingModuleId, data) =>
  http
    .put(`/training-modules/${trainingModuleId}/company-trainers`, data)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const getCompanyTrainingModuleSettings = trainingModuleId =>
  http
    .get(`/training-modules/${trainingModuleId}/company-settings`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const toggleCompanyTrainingModuleMethod = (trainingModuleId, trainingMethod, isEnabled) =>
  http
    .patch(`/training-modules/${trainingModuleId}/company-settings/methods/${trainingMethod}`, { isEnabled })
    .then(res => res.data)
    .catch(error => error.response?.data || error);
